import { useAuthenticator } from '@aws-amplify/ui-react';
import { CardMedia, CircularProgress, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Branding } from '../../branding';
import { setUser } from '../../redux/actions';
import Footer from '../Footer/Footer';

const useStyles = makeStyles((theme) => ({

    rootGrid: {
        marginTop: theme.spacing(10),
        paddingBottom: theme.spacing(3),
    },
    grid: {
        justifyContent: 'center',
        direction: "row"
    },
    cardMedia: {
        width: 200,
        height: 90,
        backgroundSize: 'contain',
    },
    typoToS: {
        paddingTop: theme.spacing(3),

    },
    linkTos: {
        fontSize: 12,
        fontWeight: "bold",
        color: Branding.secondary,
        '&:hover': {
            cursor: 'pointer',
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    link: {
        fontSize: 12,
        fontWeight: "bold",
        color: Branding.link,
        '&:hover': {
            cursor: 'pointer',
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    midBul: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        color: Branding.secondary,
    },
    message: {
        fontWeight: 'bold',
        marginTop: "2em",
        fontSize: "12px",
        color: Branding.primary
    }

}));


const mapStateToProps = (state) => {
    return {
        user: state.app.user,
        lang: state.app.lang,
        tos: state.app.tos,
    }
};

const SpinnerPage = (props) => {
    const classes = useStyles();
    const { route, user } = useAuthenticator((context) => [context.route, context.user]);
    const navigate = useNavigate();
    let from = props.state?.from?.pathname || '/';

    React.useEffect(() => {
        if (route === 'authenticated' && user) {
            props.setUser(user);
            navigate(from, { replace: true });
        }
        else if (route === "setup" && !user) {
            navigate(from, { replace: true, state: { route: route } }, { state: { route: route } });

        }
    }, [route, user, navigate, from])

    return (
        <div>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                className={classes.rootGrid}>
                <CardMedia
                    className={classes.cardMedia}
                    image={"https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png"}
                    title={Branding.appName} />
            </Grid>

            <Grid container alignItems="center" direction="column"
                justifyContent="center" className={classes.grid}>
                <CircularProgress variant='indeterminate' thickness={3} size={"2em"} />
                <Typography style={{ marginBottom: "2em" }} className={classes.message}> Please wait… </Typography>
            </Grid>

            <Footer></Footer>

        </div>
    )
}

export default connect(mapStateToProps, { setUser })(SpinnerPage);